// extracted by mini-css-extract-plugin
export default {"page":"BoothSetup_page__Ifuy9"};